import openFormStatus from '../form/form';

$('#uPhone').mask("+7 (999) 999-99-99");

$('.go-to').click(function (e) {
  e.preventDefault();

  // возьмем содержимое атрибута href, должен быть селектором, т.е. например начинаться с # или .
  let scroll_el = $(this).attr('href');

  // проверим существование элемента чтобы избежать ошибки
  if ($(scroll_el).length != 0) {
    // анимируем скроолинг к элементу scroll_el
    $('html, body').animate({ scrollTop: $(scroll_el).offset().top }, 500);
  }
});

// загружаем и валидируем файл
$('#uProfile').change(function () {
  const files = $(this).prop('files');
  const fileName = files[0].name;
  const fileType = files[0].type;

  if (fileType == 'application/octet-stream') {
    console.log('Invalid file type: ' + fileType);
    openFormStatus('Ошбика!',
      'Вы пытаетесь загрузить недопустимый тип файла. Загрузить можно только документы: DOC, DOCX, PDF, TXT, PNG, JPG');

    return false;
  }

  $('.form__label[for="uProfile"]')
    .html(fileName)
    .css({
      'background-image': 'none',
      'padding': '1.25rem'
    });
});

// отправка формы
$('#uForm').submit(function(event) {
  event.preventDefault();

  //  создаем новый экземпляр объекта и передаем ему нашу форму (*)
  const formData = new FormData($(this).get(0));

  $.ajax({
    url: '/mail-jobs.php',
    type : 'POST',
    processData: false,
    contentType: false,
    cache:false,
    data: formData,
    success: function(e){
      const response = JSON.parse(e);
      console.log(response);

      if (response.status) {
        openFormStatus('Спасибо!', 'Ваше резюме отправлено. <br>Мы обязательно посмотрим его.');
      } else {
        openFormStatus('Ошибка!', 'По каким-то причинам не удалось отправить письмо :(');
      }
    }
   });
});



// WEBPACK FOOTER //
// ./app/blocks/form-profile/form-profile.js